const angular = require('angular');

export class ToolbarComponent {
    radioModel: any;
    active: any;

    constructor() {
        this.radioModel = this.active;
    }
}

export default angular.module('directives.toolbar', [])
  .component('toolbar', {
    template: require('./toolbar.html'),
    controller: ToolbarComponent,
    bindings: {
        active: '@',
        onToolbarClick: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/toolbar/toolbar.component.ts